<div class="wrapper__form container mt-5 mb-3 border__form text-center" style="max-width: 500px">
  <img
    src="assets/img/Logo__Justifacil.png"
    alt="Logo JustiFácil"
    class="mb-4"
    style="max-height: 60px"
  />

  <h2 class="mb-2 text-primary">{{ 'verificacion_identidad.titulo_codigo' | translate }}</h2>
  <p class="text-muted mb-4">{{ 'verificacion_identidad.mensaje_codigo' | translate }}</p>

  <h4 class="mb-3 fw-bold">
    {{ 'verificacion_identidad.demanda' | translate }} {{tramiteId}}
    <span class="text-danger">{{ correo }}</span>
  </h4>

  <form [formGroup]="formularioCodigo" (ngSubmit)="verificarCodigo()">
    <div class="form-group mb-3 text-start">
      <label for="codigo" class="form-label fw-semibold">{{ 'verificacion_identidad.ingrese_codigo' | translate }}</label>
      <input
        type="text"
        id="codigo"
        formControlName="codigo"
        class="form-control"
        maxlength="6"
        placeholder="{{ 'verificacion_identidad.placeholder_codigo' | translate }}"
        [ngClass]="{ 'is-invalid': enviado && formularioCodigo.get('codigo')?.invalid }"
        autocomplete="off"
      />
      <div class="invalid-feedback" *ngIf="formularioCodigo.get('codigo')?.errors?.['required']">
        {{ 'verificacion_identidad.error_codigo_requerido' | translate }}
      </div>
      <div class="invalid-feedback" *ngIf="formularioCodigo.get('codigo')?.errors?.['minlength'] || formularioCodigo.get('codigo')?.errors?.['maxlength']">
        {{ 'verificacion_identidad.error_codigo_longitud' | translate }}
      </div>
    </div>

    <button type="submit" class="btn btn-primary w-100"
    aria-label="Verificar código">
      {{ 'verificacion_identidad.boton_verificar' | translate }}
    </button>

    <div class="text-danger mt-3" *ngIf="mensajeError">
      {{ mensajeError }}
    </div>
  </form>

  <p class="mt-4 text-muted small">
    {{ 'verificacion_identidad.politica' | translate }}
  </p>
</div>
